import React from 'react'
import pic from '../Images/img1.PNG'
import pic0 from '../Images/img2.PNG'
import pic1 from '../Images/img3.jpg'
import 'aos/dist/aos.css'

export default function Edu() {
  return (
    <>
    <p className='flex justify-center mt-10 sm:mt-20 md:mt-40 text-2xl sm:text-4xl text-slate-300 font-cust'>Timelines</p>
    
    <div className='pt-20 relative container mx-auto px-6 flex flex-col mt-20 space-y-10'>
      <div 
      className='absolute w-2 z-0 h-full bg-white bg-opacity-30 shadow-md inset-0 left-17 md:mx-auto md:right-0 md:left-0'
      >
      </div>

      <div className='relative z-10 '>
          <img alt="" src={pic} className='h-24 w-24  md:mt-5
          rounded-full object-cover shadow-2xl 
          shadow-sky-500 border-4 border-white xs:absolute md:mx-auto md:left-0 md:right-0 ' />

           <div className='relative pt-4 xs:pl-28 md:w-1/2 md:ml-auto md:pl-16 md:mt-5'>
              <div className='absolute inset-0 left-10 h-4 w-4 rounded-full bg-white xs:top-11 xs:left-24 md:left-12' 
              aria-hidden="true"></div>
               <div data-aos="fade-down-left" className='bg-white bg-opacity-10 p-6 text-white rounded-xl md:border hover:border-0 md:border-b-0 md:border-r-0 border-white hover:border-sky-500 shadow-md shadow-black hover:shadow-sky-500'>
                 <p className='font-bold text-xl'>Engineering</p>
                 <p className='text-gray-300 text-xs'>Pranveer Singh Institute of Technology, KANPUR ( AKTU ) 
                 <br/>2019-2023</p>
                 <div className='pt-2'>Pursuing my Bachelor's in Computer Science & Engineering with 7.5+ SGPA in each semester yet.</div>
                 </div>
           </div>
      </div>
      

      <div className='relative z-10 '>
          <img alt="" src={pic0} className='h-24 w-24  md:mt-10
          rounded-full object-cover shadow-2xl 
          shadow-green-500 border-4 border-white xs:absolute md:mx-auto md:left-0 md:right-0  ' />

           <div className='relative pt-4 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-0 md:mr-auto md:pl-0 md:pr-16 md:mt-10'>
              <div className='absolute inset-0 md:left-auto left-10 h-4 w-4 rounded-full bg-white xs:top-11 xs:left-24 md:right-12' 
              aria-hidden="true"></div>
               <div data-aos="fade-down-right"  className='bg-white bg-opacity-10 p-6 text-white md:border border-white hover:border-green-500 hover:border-0  md:border-b-0 md:border-l-0 rounded-lg shadow-md shadow-black hover:shadow-green-500'>
               <p className='font-bold text-xl'>Intermediate</p>
               <p className='text-gray-300 text-xs'>Dr. Virendra Swarup Education Centre, KANPUR<br/> ( CBSE )</p>
                <div className='pt-2'>Completed senior secondary education with the PCM stream and achieved a percentage of 87.2%</div>
               </div>
           </div>
      </div>

      
      <div className='relative z-10 '>
          <img alt="" src={pic1} className='h-24 w-24 md:mt-10 
          rounded-full object-cover shadow-2xl 
          shadow-yellow-500 border-4 border-white xs:absolute md:mx-auto md:left-0 md:right-0 ' />

           <div className='relative pt-4 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-auto md:pl-16 md:mt-10'>
              <div className='absolute inset-0 left-10 h-4 w-4 rounded-full bg-white xs:top-11 xs:left-24 md:left-12' 
              aria-hidden="true"></div>
               <div data-aos="fade-down-left"  className='bg-white bg-opacity-10 p-6 text-white md:border md:border-b-0 md:border-r-0 border-white hover:border-yellow-500 rounded-lg shadow-md shadow-black hover:shadow-md hover:shadow-yellow-600 hover:border-0'>
               <p className='font-bold text-xl'>High School</p>
               <p className='text-gray-300 text-xs'>Dr. Virendra Swarup Education Centre, KANPUR <br/> ( CBSE )</p>
                <div className='pt-2'>Completed my High school with a percentage of 81.7%</div>
               </div>
           </div>
          
        </div>

        <div className='relative h-5 w-5 inset-0 rounded-full bg-white shadow-xl shadow-violet-500 animate-spin left-9.5  md:mt-25 md:mx-auto md:left-0 md:right-0' 
            aria-hidden="true"></div>
      </div>

      
    </>
  )
}
